// ui
export const UI_INITIALIZE = 'UI_INITIALIZE';
export const UI_CONFIG_SET = 'UI_CONFIG_SET';
export const UPDATE_ID = 'UPDATE_ID';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_CONFIG_KEY = 'SET_CONFIG_KEY';

export const PIN_DISCOVERY_FAILURE = 'PIN_DISCOVERY_FAILURE';

export const FB_VALIDATION_STORAGE = 'FB_VALIDATION_STORAGE';

export const VALIDATION_REQUEST_AUTH = 'VALIDATION_REQUEST_AUTH';
export const VALIDATION_REQUEST_AUTH_FAIL = 'VALIDATION_REQUEST_AUTH_FAIL';
export const VALIDATION_REQUEST_AUTH_SUCCESS = 'VALIDATION_REQUEST_AUTH_SUCCESS';

export const CCR_VALIDATION_REQUEST_AUTH = 'CCR_VALIDATION_REQUEST_AUTH';
export const CCR_VALIDATION_REQUEST_AUTH_FAIL = 'CCR_VALIDATION_REQUEST_AUTH_FAIL';
export const CCR_VALIDATION_REQUEST_AUTH_SUCCESS = 'CCR_VALIDATION_REQUEST_AUTH_SUCCESS';

export const INCREMENT_FAILED_ATTEMPTS = 'INCREMENT_FAILED_ATTEMPTS';